import React from "react";

const AlertComponent = ({ title, content }) => {
  return (
    <>
      <div
        className="w-full flex flex-col items-end bg-blue-100  border-b border-blue-500 text-blue-700 mb-4 px-4 py-3 border-t"
        role="alert"
      >
        <p className="font-bold">{title}</p>
        {content ? <p className="text-sm">{content}</p> : ""}
      </div>
    </>
  );
};

export default AlertComponent;
